import { registerPlugin } from "@capacitor/core";

export interface UserIdPlugin {
  getUserId(): Promise<any>;
}

const UserId = registerPlugin<UserIdPlugin>("UserId");

export default UserId;

// const exec = async () => {
// const { value } = await Echo.echo({ value: "Hello World!666" });
// console.log("Echo Response from native:", value);
// }
